import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import BenefitsSection from './components/BenefitsSection';
import TrustSection from './components/TrustSection';
import MidFunnelCTA from './components/MidFunnelCTA';
import TrialOfferSection from './components/TrialOfferSection';
import TestimonialsSection from './components/TestimonialsSection';
import OfferSection from './components/OfferSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';

export default function Home() {
  const scrollToForm = () => {
    const el = document.getElementById('formular');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToTrial = () => {
    const el = document.getElementById('vier-wochen');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />
      <main>
        <HeroSection onCtaClick={scrollToForm} />
        <StatsBar />
        <ProblemSection />
        <SolutionSection onCtaClick={scrollToForm} />
        <BenefitsSection />
        <TrustSection onCtaClick={scrollToForm} />
        <MidFunnelCTA onCtaClick={scrollToTrial} />
        <TrialOfferSection onCtaClick={scrollToForm} />
        <TestimonialsSection />
        <OfferSection />
        <FAQSection />
        <FinalCTASection onCtaClick={scrollToTrial} />
      </main>
      <Footer />
    </div>
  );
}
